import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

const getTypeJobs = gql`
query ($name: String!) {
  Type(name: $name){
      id,
      name
  }
}
`;

const getUserVisions = gql`
  query ($email: String!) {
    User(email: $email){
        id,
        name,
        auth0UserId,
        surveys{
            id,
            title
        }
    }
  }
`;

const getUserOffers = gql`
query ($email: String!) {
  User(email: $email){
      id,
      surveys{
        id,
        title,
        offers {
          id,
          title,
        }
      }
  }
}
`;

const getUserVisionsCriterias = gql`
query ($email: String!) {
  User(email: $email){
      id,
      name,
      auth0UserId,
      surveys{
          id,
          title,
          criterias {
            id,
            title,
            importance,
            options {
              id,
              title,
              importance
            }
          },
          offers{
            id
          }
      }
  }
}
`;

const getVision = gql`
query getSurvey($id: ID) {
  Survey(id:$id){
    id,
    title,
    criterias {
      id,
      title,
      importance,
      options {
        id,
        title,
        importance
      }
    }
}
}
`;

const deleteVision = gql`
mutation deleteSurvey($id: ID!) {
  deleteSurvey(id: $id) {
    id
  }
}`;

const addVision = gql`
mutation addVision($title: String!, $createdate: DateTime!, $userId: ID, $typeId: ID) {
  createSurvey(title: $title, createdate: $createdate, userId: $userId, typeId: $typeId) {
    id,
    title,
    createdate
  }
}`;

@Injectable()
export class VisionService {
  jobsType = '';

  constructor(private apollo: Apollo) {
    this.getTypeJobs('jobs').valueChanges.subscribe(({ data }: any) => {
      this.jobsType = data.Type.id;
    });
  }

  getTypeJobs(name: string) {
    return this.apollo.watchQuery<{ data: any }>({
      query: getTypeJobs,
      variables: {
        name: name
      }
    });
  }

  getUserVisions(email: string) {
    return this.apollo.watchQuery<{ User }>({
      query: getUserVisions,
      variables: {
        email: email
      }
    }).valueChanges.map(({ data: User }) => User);
  }

  getUserOffers(email: string) {
    return this.apollo.watchQuery<{ User }>({
      query: getUserOffers,
      variables: {
        email: email
      }
    }).valueChanges.map(({ data: User }) => User);
  }

  getUserVisionsCriterias(email: string) {
    return this.apollo.watchQuery<{ User }>({
      query: getUserVisionsCriterias,
      variables: {
        email: email
      },
      pollInterval: 1000,
    }).valueChanges.map(({ data: User }) => User);
  }

  addNewVision(title: string, email: string, userId: string, typeId: string) {
    return this.apollo.mutate({
      mutation: addVision,
      variables: {
        title: title,
        userId: userId,
        typeId: this.jobsType,
        createdate: new Date,
      }
    });
  }

  getVisionData(surveyId: string) {
    return this.apollo.watchQuery<{ Survey }>({
      query: getVision,
      variables: {
        id: surveyId
      },
      pollInterval: 1000,
    }).valueChanges.map(({ data: Survey }) => Survey);
  }

  deleteVision(visionId: string) {
    return this.apollo.mutate({
      mutation: deleteVision,
      variables: {
        id: visionId,
      }
    }).map(({ data }: any) => data);
  }

  buildDeleteVision(visionId) {
    let index = 1;
    let deleteVisionString = ``;

    deleteVisionString += `
      deleteSurvey${index}: deleteSurvey(id: "${visionId}") {
          id,
          title,
      }`;

      deleteVisionString += ``;
    return deleteVisionString;
  }

  getTypeJobsId() {
    return this.jobsType;
  }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/services/vision.service.ts